<template>
  <v-draggable>
    <v-window ref="window" defaultClosed :class="$style.chat" padding="2rem 1rem" width="29.4rem" title="Chat">
      <div :class="$style.content" ref="chat" @scroll="handleScroll">
        <div v-for="(mess, index) in data" :class="[$style.message, mess.author !==  'zap' && $style.incoming]" :key="index">
          <div :class="$style.messContent">
            <div v-if="mess.type === 'img'" :class="$style.img" :style="{ backgroundImage: `url(${mess.text})` }"></div>
            <span v-else :class="$style.text">{{mess.text}}</span>
          </div>
          <div :class="$style.avatar" :style="{ backgroundImage: 'url(' + require(`./assets/${mess.author}.svg`) + ')' }"></div>
        </div>
      </div>
      <div v-if="showBtn" :class="$style.scrollBtn" @click="scrollDown"></div>
    </v-window>
  </v-draggable>
</template>
<script>
export default {
  name: 'chat',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showBtn: true,
    }
  },
  methods: {
    open() {
      this.$refs.window.open()
    },
    close() {
      this.$refs.window.close()
    },
    check() {
      this.form.checked = true
      this.data.tasks[0].ready = true
    },
    scrollDown() {
      const { chat } = this.$refs
      chat.scrollTop = chat.scrollHeight
      this.showBtn = false
    },
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } = this.$refs.chat
      this.showBtn = scrollTop < scrollHeight - clientHeight
    },
  },
}
</script>
<style lang="scss" module src="./chat.scss"></style>
